import { Helmet } from "react-helmet";

const TDConfirmationPageScript = ({transactionId, ordervalue}) => {
  if (process.env.REACT_APP_ENVIRONMENT !== "prod") {
    return null;
  }
  return (
    <Helmet>
      <script type="text/javascript">
        {`
        var TDConversion = {
      transactionId: ${transactionId},
      ordervalue: ${ordervalue},
      currency: 'USD',
      event: 467672,
      voucher: '',
      cdt: {
        extId: '',
        extType: 1
      },
      validOn: '',
      products: ''
    }; 

    tdconv('track', 'sale', TDConversion);
    tdfallback('https://a.imgstatics.com/trsdk');
    `}
      </script>
    </Helmet>
  );
};

export default TDConfirmationPageScript;
